import api from '@pray/shared/utils/api';
import type { PaginatedListResponse } from '@pray/shared/utils/api/types/response';

import type { SubscriptionResponse, PaginationParams } from './types';

type GetMemberSubscriptionsParams = PaginationParams & {
  status?: 'active' | 'cancelled' | 'expired' | 'all';
};

export async function getMemberSubscriptions(memberId: string, params: GetMemberSubscriptionsParams = {}) {
  const url = `/web/studio/users/${memberId}/products-subscriptions`;

  const queryParams: Record<string, unknown> = {
    limit: params.limit ?? 50,
    offset: params.offset ?? 0,
  };

  if (params.status && params.status !== 'all') {
    queryParams.status = params.status;
  }

  const response = await api.executeGetRequest<PaginatedListResponse<SubscriptionResponse>>(url, queryParams);

  return response.data;
}
